






























































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

import AusterButton from "@/components/AusterButton.vue";

import appointmentModel from "@/models/appointment.model";

@Component({
  components: {
    AusterButton,
    ClipLoader,
  },
})
export default class Appointments extends Vue {
  currentPage = 1;
  lastPage = 0;
  history = false;
  incompleteRecord = false;
  appointmentsEvents: any[] = [];
  loading = false;

  showDetailsModal = false;
  detailsAppointmentEvent: any = null;

  async mounted() {
    this.loadAppointments().catch(error => console.error(error));
    const incomplete = await appointmentModel.getIncomplete();
    //console.log("incomplete", incomplete);
    if (incomplete !== null && incomplete.id > 0) {
      this.history = true;
      this.incompleteRecord = true;
    }
  }

  async changePage(pageDelta = 1) {
    if (this.currentPage + pageDelta >= 1 && this.currentPage + pageDelta <= this.lastPage) {
      this.currentPage = this.currentPage + pageDelta;
      await this.loadAppointments();
    }
  }

  async loadAppointments() {
    this.loading = true;
    try {
      ({ lastPage: this.lastPage, results: this.appointmentsEvents } = await appointmentModel.getAppointmentsLatestEvents(this.currentPage, this.history));
      if (this.appointmentsEvents) {

        //console.log("logD", this.appointmentsEvents);
        this.appointmentsEvents.forEach(async ev => {
          //console.log(ev);
          ev.appointmentStartDateTime = ev.appointmentStartDateTime.replace('Z', '');
          ev.appointment.kind = await appointmentModel.translateSelectValue("status", ev.appointment?.status);
        });
      }
    } catch (error) {
      console.error(error);
    }
    this.loading = false;
  }

  getEventStatus(appointmentEvent: any) {

    //const appointmentStatus = await appointmentModel.translateSelectValue("status", appointmentEvent.appointment?.status);
    const appointmentStatus = appointmentEvent.appointment?.kind;
    //console.log("status", appointmentEvent.appointment?.status, " ", appointmentStatus);

    if (appointmentEvent.appointment?.status === "COMPLETED") {
      //return { class: "text-green-300", text: "Consulta realizada", detailsText: this.userRole === "PSYCHOLOGIST" ? "(Prontuário)" : "" };
      return { class: "text-green-300", text: appointmentStatus, detailsText: this.userRole === "PSYCHOLOGIST" ? "(Prontuário)" : "" };
    }

    //comentado em 30/09/2024 
    if (appointmentEvent.appointment?.status === "FAILED") {
      //return { class: "text-red-300", text: "Consulta não realizada", detailsText: "(status)" };
      return { class: "text-red-300", text: appointmentStatus, detailsText: "(status)" };
    }

    switch (appointmentEvent.kind) {
      case "SCHEDULED":
        //return { class: "text-yellow-300", text: "Voucher pendente", detailsText: this.userRole === "PATIENT" ? "(Realizar o envio do voucher)" : "" };
        return { class: "text-yellow-300", text: appointmentStatus, detailsText: this.userRole === "PATIENT" ? "(Realizar o envio do voucher)" : "" };
      case "RECEIPT_SENT":
        //return { class: "text-yellow-300", text: "Aguardando confirmação", detailsText: this.userRole === "PSYCHOLOGIST" ? "(Verificar)" : "" };
        return { class: "text-yellow-300", text: appointmentStatus, detailsText: this.userRole === "PSYCHOLOGIST" ? "(Verificar)" : "" };
      case "VOUCHER_APPLIED":
      case "CONFIRMED":
        //return { class: "text-green-300", text: "Consulta confirmada", detailsText: "(Saiba mais)" };
        return { class: "text-green-300", text: appointmentStatus, detailsText: "(Saiba mais)" };
      case "REFUSED":
        //return { class: "text-red-300", text: "Comprovante recusado", detailsText: "(Saiba mais)" };
        return { class: "text-red-300", text: appointmentStatus, detailsText: "(Saiba mais)" };
      case "CANCELLED":
        //return { class: "text-red-300", text: "Consulta cancelada", detailsText: "(Saiba mais)" };      
        return { class: "text-red-300", text: appointmentStatus, detailsText: "(Saiba mais)" };      
    }
    return { class: "text-red-300", text: "-", detailsText: "-" };
  }

  openDetails(appointmentEvent: any) {
    switch (appointmentEvent.kind) {
      case "REFUSED":
      case "CANCELLED":
        this.detailsAppointmentEvent = appointmentEvent;
        this.showDetailsModal = true;
        break;
      case "RECEIPT_SENT":
        this.$router.push("/dash/solicitacoes");
        break;
      default:
        if (appointmentEvent.appointment?.id) {
          this.$router.push(`/dash/consulta/${appointmentEvent.appointment.id}`)
        } else {
          console.error("Appointment has no id");
        }
    }
  }

  @Watch("history")
  async historyUpdated(history, previousHistory) {
    if (history !== previousHistory) {
      await this.loadAppointments();
    }
  }

  get userRole() {
    return this.$store.state.activeUser?.role;
  }
}
